import axios from "axios";
import { getUserToken } from "./utils";
import { reportApiError, reportApiUp } from "./apiStatus";
export const itemsPerPage = 10;
// 1. Create the Instance (Reviewer's Fix)
const apiClient = axios.create({
  // baseURL: "https://splitpos.com:8080/api/",
  // baseURL: "https://stagingapi.splitpos.com/api/",
  baseURL: process.env.REACT_APP_API_BASE_URL || "",
  headers: {
    "Content-Type": "application/json",
  },
});

// 2. Request Interceptor: Handles Authorization for ALL requests automatically
apiClient.interceptors.request.use(
  (config) => {
    const tokenData = getUserToken();
    try {
      const apitoken = tokenData || null;
      if (apitoken) {
        config.headers.Authorization = `Bearer ${apitoken}`;
      }
    } catch (error) {
      console.error("Token parsing failed", error);
    }
    return config;
  },
  (error) => {
    // CRITICAL: Always return a rejected promise on interceptor failure
    return Promise.reject(error);
  },
);

// Tracks whether the API is reachable, for the maintenance screen. Attached
// here rather than in setupInterceptors so it is active from the first request.
apiClient.interceptors.response.use(
  (response) => {
    reportApiUp();
    return response;
  },
  (error) => {
    reportApiError(error, apiClient.defaults.baseURL);
    return Promise.reject(error);
  },
);

export const getApiBaseUrl = () => apiClient.defaults.baseURL;

const handleInvalidToken = (navigate) => {
  localStorage.clear();
  if (navigate) navigate("/sign-in");
  else window.location.href = "/sign-in";
};

// 3. Response Interceptor: Replaces your old setupInterceptors
let isInterceptorAttached = false; // Flag to prevent stacking
export const setupInterceptors = (navigate) => {
  if (isInterceptorAttached) return;
  isInterceptorAttached = true;
  apiClient.interceptors.response.use(
    (response) => {
      if (response?.data?.message === "Invalid token!") {
        handleInvalidToken(navigate);
        return new Promise(() => {});
      }
      return response;
    },
    (error) => {
      const status = error.response?.status;
      const msg = error?.response?.data?.message;
      if (
        status === 401 ||
        msg === "Invalid token!" ||
        msg === "Unauthorized access token!"
      ) {
        handleInvalidToken(navigate);
        return new Promise(() => {});
      }
      return Promise.reject(error);
    },
  );
};
// --- CLEANED API METHODS ---
// POST
export const postReq = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody);
};
export const postReqWithFile = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postReqForOnlineForm = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postReqwithoutHeader = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody, {
    headers: { Authorization: "" },
  });
};

// GET
// `config` is optional axios config, e.g. { signal } for AbortController.
export const getReq = (apiPath, config) => {
  return apiClient.get(apiPath, config);
};

// GET a file (CSV, PDF…) as a Blob instead of parsed JSON.
export const getBlobReq = (apiPath) => {
  return apiClient.get(apiPath, { responseType: "blob" });
};

export const getById = (apiPath, id) => {
  return apiClient.get(apiPath, {
    params: { agentId: id },
  });
};

// PUT
export const putReq = (apiPath, reqBody) => {
  return apiClient.put(apiPath, reqBody);
};

export const putReqForEmp = (apiPath, reqBody) => {
  return apiClient.put(apiPath, reqBody, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// DELETE
export const delWithBodyReq = (apiPath, reqBody) => {
  return apiClient.delete(apiPath, { data: reqBody });
};

export const delReq = (apiPath, id, role) => {
  const roleMap = {
    department: "departmentId",
    flag: "flagId",
    payout: "payoutId",
    product: "itemId",
    promotion: "promotionId",
    combinedPromotion: "combinedPromotionId",
    customer: "customerId",
    customerGroup: "customerGroupId",
    selectedItems: "selectedItems",
    empTask: "taskId",
  };

  const idKey = roleMap[role];
  return apiClient.delete(apiPath, {
    data: idKey ? { [idKey]: id } : {},
  });
};
